import { ApiResponse } from 'apisauce';

export const handleApiResponse = <TData = any>(response: ApiResponse<TData>) => {

	if (response.ok) {
		return response.data;
	}
	
	throw response.data;
	
};
